<!-- IIT2-1435:- start -->
<div class="fade show partner_content" id="reviewComment">
  <div class="view_partner_data" id="reviewCommentPartnerData">
    <div class="title_bar" id="titleBarConName">
      <img class="page_back_icon" alt="go back" (click)="goBackToReview()" />
      <span class="title">{{contentName}}</span>
    </div>

    <!-- Section 1 - Model SKU Info -->
    <section>
      <div class="section_header" id="secHeaderSKUInfo">
        <img class="sku" alt="SKU info" />
        <span i18n="@@review-comment.model-sku-info.model-sku-info">MODEL SKU INFO</span>
      </div>
      <div class="section_body model_info_section" id="modelInfoSecSystemId">
        <div class="info_group" id="infoGrpSystemId">
          <label><span i18n="@@review-comment.system-id.system-id">System ID</span></label>
          <div class="systemId_text" ngbTooltip="{{systemID}}" id="systemIdText">{{systemID}}</div>
        </div>
        <div class="info_group" *ngIf="publishDate?.length" id="infoGrpPublishDate">
          <div id="publishDateTIme">
            <label><span i18n="@@segments.expanded-segment.publish-date">Publishing Date and Time</span></label>
            <div>
              {{publishDate| dateFormat: "24hrP" }}
            </div>
          </div>
          <div class="mt-2" *ngIf="expiryDate?.length" id="infoGrpExpiryDateTime">
            <label><span i18n="@@segments.expanded-segment.expire-date">Expiration Date and Time</span></label>
            <div id="expiryDate24Format">
              {{expiryDate| dateFormat: "24hrP" }}
            </div>
          </div>
        </div>
        <div class="info_group" id="infoGrpDisplayName">
            <label><span i18n="@@review-comment.display-name.display-name">Display Name</span></label>
            <span>
              <ng-container *ngIf="displayVal?.length">
                <ng-container *ngFor="let data of displayVal, let i = index, let c = count">
                  {{i < c-1 ? (data + ' - ' + displayLang[i] + ', ' ) : data + ' - ' + displayLang[i]}} </ng-container>
                </ng-container>
                <ng-container *ngIf="!displayVal?.length">
                  {{disvalue}} - {{englishLang}}
                </ng-container>
            </span>
          </div>
          <div id="systemModels">
            <div class="info_group" id="infoGrpSystemModels">
              <label>
                <span i18n="@@review-comment.system-models.system-models">System Models</span>
              </label>
            </div>
            <div class="info_group_chip" id="infoGrpChip">
              <ng-container *ngIf="!singleData">
                <ng-container *ngFor="let data of parsedData">
                  <span class="chip">{{data}}</span>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="singleData">
                <span class="chip">{{parsedData}}</span>
              </ng-container>

            </div>
          </div>
      </div>
      <div class="boldClass" id="operatingSysCon">
        <label><span i18n="@@review-comment.os-operating-system">Operating System</span></label>
        <span>{{contentData?.operatingSystem}}</span>
      </div>

    </section>

    <!-- Section 2 - Language -->
    <section>
      <div class="section_header" id="reviewComentLang">
        <img class="lang" alt="language" />
        <span i18n="@@review-comment.language.language">LANGUAGE</span>
      </div>
      <div class="section_body" id="sectionBody">
        <div class="info_group mb-4" id="languageCategory">
          <label><span i18n="@@review-comment.language.category-language.category">Language Category</span></label>
          <span>{{languageCategory}}</span>
        </div>
        <div class="info_group" id="languages">
          <label><span i18n="@@review-comment.languages.languages">Languages</span></label>
          <span>{{displayLanguage}}</span>
        </div>
      </div>
    </section>

    <!-- Section 3 - tile thumbnail -->
    <section>
      <div class="section_header" id="sectionHeader3">
        <img class="thumbnail" alt="thumbnail section" />
        <span i18n="@@review-comment.tile-thumbnail.tile-thumbnail">TILE THUMBNAIL</span>
      </div>
      <div class="section_body" id="sectionBody3">
        <!-- get this image from api -->
        <img class="reduceMinHeight" [src]="imageUrl" alt="thumbnail" />
      </div>
    </section>

    <!-- Section 4 - Pages -->
    <section>
      <div class="section_header" id="sectionHeader4">
        <img class="page" alt="language" />
        <span i18n="@@review-comment.pages.pages">PAGES</span>
      </div>
      <div class="section_body pages_preview" *ngIf="contentGroupPages?.length > 0" id="sectionBody4">
        <iposcen-pages-view [configData]="contentGroupPages" [autoID]="autoID"></iposcen-pages-view>
      </div>
    </section>
    <!-- IIT2-1436-start -->
    <!-- Section 5 - Comments -->
    <section>
      <div class="section_header" id="sectionHeader5">
        <img class="chat_quote" alt="provide comments" />
        <span i18n="@@review-comment.your-comments.your-comments">YOUR COMMENTS</span>
      </div>
      <div class="section_body d-block" id="sectionBody5">
        <div class="mb-3" id="skuProfileOnceReturned">
          <span i18n="@@review-comment.your-comments-creator.your-comments-will-be-sent-to-the-creator-of-this-hero-sku-profile-once-returned">Your comments will be sent to the creator of this Partner Content once returned.</span>
        </div>
        <div class="form-group" id="frmGrpComments5">
          <label><span i18n="@@review-comment.comments.comments">Comments</span></label>
          <textarea (input)='getComment($event.target.value)' class="form-control" rows="3"
            placeholder="Please enter your feedback for this Partner Content."></textarea>
        </div>
      </div>
    </section>
    <!-- IIT2-1436-end -->
    <!-- IIT2-1437-start -->
    <div class="button_wrapper" id="reviewPopupBtns">
      <button [disabled]='!commentData' (click)='openPopup(reviewPopup,"returned")'
        class="btn btn-outline-danger btn-lg left_icon_btn">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M12 22.5C14.7848 22.5 17.4555 21.3938 19.4246 19.4246C21.3938 17.4555 22.5 14.7848 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5C9.21523 1.5 6.54451 2.60625 4.57538 4.57538C2.60625 6.54451 1.5 9.21523 1.5 12C1.5 14.7848 2.60625 17.4555 4.57538 19.4246C6.54451 21.3938 9.21523 22.5 12 22.5ZM12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0C8.8174 0 5.76516 1.26428 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24Z" />
            <path
              d="M10.5029 16.4997C10.5029 16.3027 10.5417 16.1077 10.6171 15.9257C10.6925 15.7437 10.803 15.5783 10.9423 15.439C11.0816 15.2997 11.2469 15.1892 11.4289 15.1139C11.6109 15.0385 11.8059 14.9997 12.0029 14.9997C12.1999 14.9997 12.395 15.0385 12.577 15.1139C12.7589 15.1892 12.9243 15.2997 13.0636 15.439C13.2029 15.5783 13.3134 15.7437 13.3887 15.9257C13.4641 16.1077 13.5029 16.3027 13.5029 16.4997C13.5029 16.8975 13.3449 17.279 13.0636 17.5603C12.7823 17.8417 12.4008 17.9997 12.0029 17.9997C11.6051 17.9997 11.2236 17.8417 10.9423 17.5603C10.661 17.279 10.5029 16.8975 10.5029 16.4997ZM10.6499 7.49219C10.63 7.30295 10.65 7.11163 10.7087 6.93063C10.7675 6.74963 10.8636 6.58301 10.9909 6.44157C11.1182 6.30013 11.2738 6.18703 11.4476 6.10961C11.6215 6.03219 11.8096 5.99219 11.9999 5.99219C12.1902 5.99219 12.3784 6.03219 12.5522 6.10961C12.726 6.18703 12.8817 6.30013 13.009 6.44157C13.1362 6.58301 13.2324 6.74963 13.2911 6.93063C13.3499 7.11163 13.3699 7.30295 13.3499 7.49219L12.8249 12.7527C12.8073 12.9593 12.7127 13.1519 12.56 13.2921C12.4072 13.4324 12.2073 13.5103 11.9999 13.5103C11.7925 13.5103 11.5927 13.4324 11.4399 13.2921C11.2871 13.1519 11.1926 12.9593 11.1749 12.7527L10.6499 7.49219Z" />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span i18n="@@review-comment.return-with-comments.return-with-comments">Return with Comments</span>
      </button>
      <button (click)='openPopup(reviewPopup,"approved")' class="btn btn-outline-success btn-lg left_icon_btn">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M20.781 5.46936C20.8508 5.53903 20.9062 5.6218 20.944 5.71291C20.9818 5.80403 21.0013 5.90171 21.0013 6.00036C21.0013 6.09902 20.9818 6.1967 20.944 6.28781C20.9062 6.37893 20.8508 6.4617 20.781 6.53136L10.281 17.0314C10.2113 17.1012 10.1285 17.1566 10.0374 17.1944C9.9463 17.2322 9.84862 17.2517 9.74997 17.2517C9.65132 17.2517 9.55364 17.2322 9.46252 17.1944C9.3714 17.1566 9.28864 17.1012 9.21897 17.0314L3.96897 11.7814C3.82814 11.6405 3.74902 11.4495 3.74902 11.2504C3.74902 11.0512 3.82814 10.8602 3.96897 10.7194C4.1098 10.5785 4.30081 10.4994 4.49997 10.4994C4.69913 10.4994 4.89014 10.5785 5.03097 10.7194L9.74997 15.4399L19.719 5.46936C19.7886 5.39952 19.8714 5.34411 19.9625 5.3063C20.0536 5.26849 20.1513 5.24902 20.25 5.24902C20.3486 5.24902 20.4463 5.26849 20.5374 5.3063C20.6285 5.34411 20.7113 5.39952 20.781 5.46936Z" />
        </svg>
        <span i18n="@@review-comment.approve-approve">Approve</span>
      </button>
    </div>
    <!-- IIT2-1437-end -->
  </div>
</div>
<!-- IIT2-1435:- end -->

<!-- popUp  -->
<ng-template #reviewPopup let-modal>
  <div class="card confirmPopup" [ngClass]="isReturnPopup || (whichPopup === 'approved' && !openPushApproveModal) ? 'confirm-modal' : ''" id="reviewPopupCard">
    <div class="modal-header" id="reviewModalHeader">
      <div (click)="closePopup(modal)" class="close-icon" id="reviewModalClose">
        <img src="../../../../../../assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div class="modal-body popup-body" [ngClass]="{'text-center':doneState}" id="reviewModalBody">
      <div *ngIf='doneState'>
        <div class="invitesuccess_img_div text-center">
          <span class="invitesuccess_img"></span>
        </div>
        <h2 class="mt-3">
          <span *ngIf='whichPopup !== "approved"'>{{partnerDataReview.contentName}} {{doneRejectLabel}}</span>
          <span *ngIf='whichPopup === "approved" && !openPushApproveModal'>{{partnerDataReview.contentName}} {{doneApproveLabel}}</span>
        </h2>
        <div class="card-desc">
          <span *ngIf='whichPopup !== "approved"'
            i18n="@@review-comment.returned-successfully">{{partnerDataReview.contentName}} has been returned to
            {{createdBy}} with your comments.</span>
          <span *ngIf='whichPopup === "approved" && !openPushApproveModal' i18n="@@review-comment.approved-successfully">You have successfully
            approved {{partnerDataReview.contentName}}.</span>
        </div>
        </div>
      <div *ngIf='!doneState' id="reviewPopupContetName">
        <h2><span *ngIf='!openPushApproveModal'>{{popupTitle}} {{partnerDataReview.contentName}} ?</span></h2>
        <h2><span *ngIf='openPushApproveModal' i18n = "@@view-attract-admin.approve-label">Approve {{contentName}} ?</span></h2>
        <div class="card-desc" id="reviewPopupCardDesc">
          <span *ngIf='whichPopup !== "approved"'
          i18n="@@review-comment.return-with-comments">{{partnerDataReview.contentName}} will be returned with
            comments.</span>
          <span *ngIf='whichPopup === "approved" && openPushApproveModal' i18n="@@view-attract-admin.confirmation-popup.would-you-like-approve-and-push">Would you like to approve and <strong>push</strong> these changes to all devices 
            currently displaying this content?</span>
        </div>
        <div class="card-desc" id="approvedPopup"><span *ngIf='whichPopup === "approved" && openPushApproveModal' i18n="@@view-attract-admin.approved-popup.click-on-approve-but-dont-push">If you click on <strong>“Approve but don’t push updates”</strong>, 
          changes will NOT be pushed to devices in real time but these changes will reflect in packages that are generated post approval.</span></div>
        <div class="card-desc card-bottom" id="cardDescApproved">
          <span *ngIf='whichPopup === "approved" && openPushApproveModal' i18n="@@view-attract-admin.approve-and-push-popup.click-approve-and-push">If you click on <strong>“Approve and push updates”</strong>, 
            changes will be pushed to devices with internet connectivity that are displaying this content.</span>
      </div>
    </div>
    </div>
    <div *ngIf="!doneState && openPushApproveModal && !isReturnPopup" class="modal-footer card-footer" id="cardFooter">
      <button type="button" data-inline="true" (click)="approveModal(modal)" class="btn btn-outline-primary btn-cancel">
        <span i18n="@@view-attract-admin.popup-modal-card-footer.click-approve-dont-push-footer">Approve but don’t push updates</span>
      </button>
      <button type="button" data-inline="true"  class="btn btn-primary btn-confirm" (click)="approveAndPushModal(modal)">
        <span i18n="@@view-attract-admin.popup-modal-card-footer.click-approve-and-push-footer">Approve and push updates</span>
      </button>
    </div>
    <div *ngIf='!doneState && !openPushApproveModal' class="modal-footer card-footer return-footer">
      <button type="button" (click)="modal.close()" class="btn btn-outline-primary btn-cancel">
        <span i18n="@@review-comment.cancel-cancel">Cancel</span></button>
      <button type="button" class="btn btn-primary btn-confirm gtmApprovePartnerContent" (click)="sendMail();">
        {{popupAction}} </button>
    </div>
  </div>
</ng-template>
<div class="container" id="containerPopup">
  <div class="modal-dialog modal-dialog-centered" *ngIf="openModal" id="reviiewModalDialog">
    <div class="modal-backdrop show" id="modalBackDrop"></div>
    <div class="modal" id="myModal">
      <div class="modal-dialog" id="myModalDialogReview">
        <div class="modal-content" id="myModalContent">
          <div class="close" data-dismiss="modal" (click)="closeModal()" id="myModalClose">
            <img class="modal-close-icon" alt="close" />
          </div>
          <div class="modal-body popup-modal" *ngIf="approved" id="myModalBody">
              <img class="check_circle" alt="check circle" />
            <div class="heading" id="myModalHeading"><span i18n="@@view-attract-admin.approve-heading.attractloop-approved">{{contentName}} Approved</span></div>
            <div class="text-body" id="myModalTxtBody"><span i18n="@@view-attract-admin.approve-text-body.attractloop-successfully-approved"><p>You have successfully approved {{contentName}}.</p></span></div>  
        </div>
        <div class="modal-body popup-modal" *ngIf="pushUpdates" id="myModalpushUpdates">
          <img class="check_circle" alt="check circle" />
        <div class="heading" id="myModalContentName"><span i18n="@@view-attract-admin.approve-heading.attractloop-approved">{{contentName}} Approved</span></div>
        <div class="text-body" id="myModalTxtBodyReview">
          <span i18n="@@view-attract-admin.approved-text.attractloop-successfully-approved-and-pushed"  *ngIf="devicesCount !== 1">
            <p>You have successfully approved {{contentName}}.Changes are pushed to {{devicesCount}} devices and these changes will reflect in devices with an active internet connection.</p>
          </span>        
          <span i18n="@@view-attract-admin.approved-text.attractloop-successfully-approved-and-pushed-to-one-device" *ngIf="devicesCount === 1">
            <p>You have successfully approved {{contentName}}.Changes are pushed to {{devicesCount}} device and these changes will reflect in device with an active internet connection.</p>
          </span>
        </div>  
        </div>
      </div>
    </div>
  </div>
</div>
</div>